module.exports = __webpack_public_path__ + "9ff105f5e7660b10a5b438cd7bd50813.svg";